import PointAndMove from './PointAndMove';

export default PointAndMove;